import { render, staticRenderFns } from "./ProtocoloLogForm.vue?vue&type=template&id=f5c73b44&scoped=true&"
import script from "./ProtocoloLogForm.vue?vue&type=script&lang=js&"
export * from "./ProtocoloLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c73b44",
  null
  
)

export default component.exports